/* 별점 — 비율만큼 부분 채움(예: 4.6 → 별 4개 + 5번째 60% 채움).
 * 각 별은 회색 빈 별 위에 금색 별을 width:fill% 로 클립한 2-레이어. (Figma star path) */

const STAR_PATH =
  "M5.00929 0C4.8186 0 4.65174 0.097561 4.55639 0.317073L3.57909 3.53659H0.480315C0.0512547 3.53659 -0.163276 4.07317 0.146601 4.39024L2.72097 6.29268L1.67215 9.39024C1.60064 9.70732 1.86284 10 2.14888 10C2.22039 10 2.31574 9.97561 2.38725 9.92683L5.00929 7.92683L7.60749 9.92683C7.679 9.97561 7.77435 10 7.84586 10C8.1319 10 8.3941 9.70732 8.29875 9.36585L7.24994 6.26829L9.84814 4.39024C10.158 4.09756 9.96732 3.53659 9.51443 3.53659H6.41565L5.46219 0.317073C5.36684 0.097561 5.19998 0 5.00929 0Z";

interface Props {
  rating: number;
  /** 컨테이너 클래스(기존 gap/레이아웃 스타일 재사용) */
  className?: string;
  /** 별 한 개 픽셀 크기 */
  size?: number;
}

export function RatingStars({ rating, className, size = 14 }: Props) {
  return (
    <span className={className} aria-hidden="true">
      {Array.from({ length: 5 }, (_, i) => {
        const fill = Math.max(0, Math.min(1, rating - i)); // 0~1
        return (
          <span
            key={i}
            className="rating-star"
            style={{ width: size, height: size }}
          >
            <svg className="rating-star__bg" viewBox="0 0 10 10" aria-hidden="true">
              <path d={STAR_PATH} fill="currentColor" />
            </svg>
            {fill > 0 && (
              <span
                className="rating-star__fill"
                style={{ width: `${fill * 100}%` }}
              >
                <svg className="rating-star__fg" viewBox="0 0 10 10" aria-hidden="true">
                  <path d={STAR_PATH} fill="currentColor" />
                </svg>
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
}
